module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("小程序封面图设置")])])], 1), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "封面图：",
      "label-width": "100px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd186de2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/other/WechatPic.vue
// module id = 761
// module chunks = 1